<section id="schedaPartner" class="content-padding darker">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="_expertForm" (ngSubmit)="onSubmit()" *ngIf="_expertForm">
      <div class="expert-personal-info">
        <fieldset>
          <legend>PERSONAL INFORMATION:</legend>
          <div class="col-48 grid-element" formGroupName="user">
            <label>Cognome{{ _expertForm.get('user').get("surname") | required }}</label>
            <input type="text" name="surname" formControlName="surname">
            <app-error-html-handler [ctrl]="_expertForm.get('user').get('surname')" [messages]="formValidationMsgs.user.surname"></app-error-html-handler>
          </div>
  
          <div class="col-48 grid-element" formGroupName="user">
            <label>Nome{{ _expertForm.get('user').get("name") | required }}</label>
            <input type="text" name="name" formControlName="name">
            <app-error-html-handler [ctrl]="_expertForm.get('user').get('name')" [messages]="formValidationMsgs.user.name"></app-error-html-handler>
          </div>
  
          <div class="col-48 grid-element" formGroupName="user">
            <label for="emailExpert">E-mail{{ _expertForm.get('user').get('email') | required }}</label>
            <input type="email" name="email" formControlName="email">
            <app-error-html-handler [ctrl]="_expertForm.get('user').get('email')" [messages]="formValidationMsgs.user.email"></app-error-html-handler>
          </div>
  
          <div class="col-48 grid-element">
            <label for="telefonoExpert">Telefono{{ _expertForm.get("phone") | required }}</label>
            <input type="text" name="phone" formControlName="phone">
            <app-error-html-handler [ctrl]="_expertForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
          </div>
  
          <div class="grid-element-full">
            <label for="indirizzoExpert">
              Indirizzo{{ _expertForm.get("address") | required }}
              <span class="directions" (click)="directions($event)"><i class="fas fa-directions"></i></span>
            </label>
            <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="_expertForm.get('address')"></app-google-maps-search>
            <app-error-html-handler [ctrl]="_expertForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
          </div>

          <br class="clear">
          
          <div class="col-48 grid-element">
            <label class="original-label">
              <input type="checkbox" name="isVatCode" formControlName="isVatCode">
              PARTITA IVA
            </label>
          </div>

          <br class="clear">

          <div class="col-48 grid-element" [ngClass]="{'hidden': !_expertForm.get('isVatCode').value}">
            <label for="partitaIVA">Partita IVA{{ _expertForm.get("vatCode") | required }}</label>
            <input type="text" name="vatCode" formControlName="vatCode">
            <app-error-html-handler [ctrl]="_expertForm.get('vatCode')" [messages]="formValidationMsgs.vatCode"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" [ngClass]="{'hidden': !!_expertForm.get('isVatCode').value}">
            <label for="cf">Codice Fiscale{{ _expertForm.get("fiscalCode") | required }}</label>
            <input type="text" name="fiscalCode" formControlName="fiscalCode">
            <app-error-html-handler [ctrl]="_expertForm.get('fiscalCode')" [messages]="formValidationMsgs.fiscalCode"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="cf">LUOGO DI NASCITA (E PROVINCIA){{ _expertForm.get("birthPlace") | required }}</label>
            <input type="text" name="birthPlace" formControlName="birthPlace">
            <app-error-html-handler [ctrl]="_expertForm.get('birthPlace')" [messages]="formValidationMsgs.birthPlace"></app-error-html-handler>
          </div>

          <div class="col-40 grid-element">
            <label>Data di nascita{{ _expertForm.get("dateOfBirth") | required }}</label>
            <input type="date" formControlName="dateOfBirth">
            <app-error-html-handler [ctrl]="_expertForm.get('dateOfBirth')" [messages]="formValidationMsgs.dateOfBirth"></app-error-html-handler>
          </div>

          <div class="grid-element-full">
            <label for="bankAccountData">Coordinate Bancarie (IBAN){{ _expertForm.get('bankAccountData') | required }}</label>
            <textarea name="bankAccountData" formControlName="bankAccountData" maxlength="34" rows="2" class="large-text-area"></textarea>
            <app-error-html-handler [ctrl]="_expertForm.get('bankAccountData')" [messages]="formValidationMsgs.bankAccountData"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="cf">Percentuale Ritenuta{{ _expertForm.get("holdingPercentage") | required }}</label>
            <input type="text" name="holdingPercentage" formControlName="holdingPercentage">
            <app-error-html-handler [ctrl]="_expertForm.get('holdingPercentage')" [messages]="formValidationMsgs.holdingPercentage"></app-error-html-handler>
          </div>

        </fieldset>
        <br class="clear">
      </div>
      
      <div class="team-leader" *ngIf="groups.includes('admin') || groups.includes('expert')">
        <fieldset>
          <legend>SALART FREQUENCY SETTING:</legend>
          <span *ngIf="groups.includes('expert')">
            <b>{{ isEligibleForWeeklyPayment ? "Hai diritto al pagamento settimanale." : "Non hai diritto al pagamento settimanale. Aumenta l'importo del tuo portafoglio." }}</b>
          </span>
          <br class="clear">
          <div class="col-48 grid-element">
              <label>Salary Frequency{{ _expertForm.get("salaryFrequency") | required }}</label>
              <select formControlName="salaryFrequency" (change)="changeSalaryFrequency($event.target.value)">
                <option value="null" selected disabled></option>
                <option *ngFor="let item of salaryFrequency | enumToArray" value="{{ item.name }}">
                  {{ salaryFrequencyAux.ln('it', item.name)?.toUpperCase() }}
                </option>
              </select>
              <app-error-html-handler [ctrl]="_expertForm.get('salaryFrequency')" [messages]="formValidationMsgs.salaryFrequency"></app-error-html-handler>
            </div> 

            <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
              <label for="cf">Limite di deposito settimanale{{ _expertForm.get("weeklyDepositLimit") | required }}</label>
              <input type="text" name="weeklyDepositLimit" formControlName="weeklyDepositLimit">
              <app-error-html-handler [ctrl]="_expertForm.get('weeklyDepositLimit')" [messages]="formValidationMsgs.weeklyDepositLimit"></app-error-html-handler>
            </div>

        </fieldset>
        <br class="clear">
      </div>

      <div class="team-leader" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>TEAM LEADER:</legend>
          <div class="col-48 grid-element"  *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label class="toggle-container" for="isTeamLeader">
              <input type="checkbox" id="isTeamLeader" formControlName="isTeamLeader">
              <span class="toggle-switch"></span>
              Team Leader
            </label>
          </div> 
          <br class="clear" [ngClass]="{'hidden': !_expertForm.get('isTeamLeader').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <br class="clear" [ngClass]="{'hidden': !_expertForm.get('isTeamLeader').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">

          <fieldset [ngClass]="{'hidden': !_expertForm.get('isTeamLeader').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <legend>Province</legend>
            <div class="grid-element-full">
              <!-- <label style="position: relative; top: 20px;">Province{{ _expertForm.get('expertTeamLeaderProvinces')?.controls[0]?.controls?.province?.id | required }}*</label> -->
              <div formArrayName="expertTeamLeaderProvinces">
                <div class="offer-products" *ngFor="let provinceForm of _expertForm.get('expertTeamLeaderProvinces').controls; let i = index">
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeTeamLeaderProvince(i)"></i>
                    </div>
                    <div class="product-q" formGroupName="province">
                      <div class="porduct-qty">
                        <div class="province-input">
                          <label for=""></label>
                          <ng-select formControlName="id">
                            <ng-option *ngFor="let province of provinces" [value]="province.id" [disabled]="isTeamLeaderProvinceOptionDisabled(province)">
                              <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <br>
                    <app-error-html-handler [ctrl]="provinceForm?.controls?.province?.controls?.id"
                      [messages]="formValidationMsgs?.expertTeamLeaderProvinces?.province?.id">
                    </app-error-html-handler>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%;">
                <button class="btn mt-0" (click)="$event.preventDefault(); addTeamLeaderProvince()">
                  Aggiungi Province<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </div>
          </fieldset>

          <br class="clear" [ngClass]="{'hidden': !_expertForm.get('isTeamLeader').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">

          <fieldset [ngClass]="{'hidden': !_expertForm.get('isTeamLeader').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <legend>PARTNERS:</legend>
            <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <div formArrayName="teamLeaderPartners">
                <div class="offer-products" *ngFor="let teamLeaderPartner of _expertForm.get('teamLeaderPartners').controls; let i = index">
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"  (click)="removePartner(i)"></i>
                    </div>
                    <div class="product-q" formGroupName="partner">
                      <div class="porduct-qty">
                        <div class="province-input">
                          <label for=""></label>
                          <ng-select 
                            formControlName="id"
                            [searchable]="true" 
                            [clearable]="true"
                            [virtualScroll]="true"
                          >
                            <ng-option 
                              *ngFor="let partner of partners" 
                              [value]="partner?.id" 
                              [disabled]="isPartnerOptionDisabled(partner)"
                            >
                              {{partner.businessName}}
                            </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <br>
                    <app-error-html-handler [ctrl]="teamLeaderPartner?.controls?.partner?.controls?.id" [messages]="formValidationMsgs?.teamLeaderPartners?.partner.id"></app-error-html-handler>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%;">
                <button class="btn mt-0" (click)="$event.preventDefault(); addPartner()">
                  Aggiungi Partner<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </div>
          </fieldset>
        </fieldset>
        <br class="clear">
      </div>

      <div class="valet-province" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>VALET PROVINCE:</legend>
          <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')">
            <label style="position: relative; top: 20px;">Province{{ _expertForm.get('expertProvinces')?.controls[0]?.controls?.province?.id | required }}*</label>
            <div formArrayName="expertProvinces">
              <div class="offer-products"
                *ngFor="let provinceForm of _expertForm.get('expertProvinces').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProvince(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="province">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                         <ng-select formControlName="id">
                          <ng-option *ngFor="let province of provinces" [value]="province.id" [disabled]="isProvinceOptionDisabled(province)">
                            <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                          </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="provinceForm?.controls?.province?.controls?.id"
                    [messages]="formValidationMsgs?.expertProvinces?.province?.id">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addProvince()">
                Aggiungi Province<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="valet-service" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>SERVIZIO: <b>(NOTE :- YOU CAN SELECT ONLY ONE HOURLY AND ONE FIXEDPRICE TYPE SERVICE)</b></legend>
          <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <!-- <label style="position: relative; top: 20px;">Servizio <b>(NOTE :- YOU CAN SELECT ONLY ONE HOURLY AND ONE FIXEDPRICE TYPE SERVICE)</b></label> -->
            <div formArrayName="expertServices">
              <div class="offer-products"
                *ngFor="let serviceForm of _expertForm.get('expertServices').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product remove-service"  (click)="removeService(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="service">
                    <fieldset style="padding-top: 0px; margin-top: 15px;">
                      <legend><b>{{  expert?.expertServices?.length ? expert?.expertServices[i]?.id : "" }}</b></legend>
                      <div class="porduct-qty">
                        <div [ngClass]="showSalaryPerItem[i] ? 'saifu-input-100-width' : 'saifu-input'">
                          <label for="">Servizio</label>
                          <ng-select bindLabel="serviceName" bindValue="id" formControlName="id" (change)="handleServiceChange($event, i)">
                            <ng-option *ngFor="let service of services" [value]="service.id" [disabled]="isOptionDisabled(service)">
                              {{ service.serviceName }}
                            </ng-option>
                          </ng-select>
                        </div>
      
                        <!-- <div class="" [ngClass]="showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input'"> -->
                        <div class="" [ngClass]="showSalaryPerItem[i] ? 'three-items' : (showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input')">
                          <label for="">Servizio Salario</label>
                          <input type="text" formControlName="salary" placeholder="Servizio Salario">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.salary"
                            [messages]="formValidationMsgs?.expertServices?.service?.salary">
                          </app-error-html-handler>
                        </div>

                        <div class="" [ngClass]="showSalaryPerItem[i] ? 'three-items' : 'saifu-input'" *ngIf="showSalaryPerItem[i]">
                          <label for="">Salary Per Item</label>
                          <input type="text" formControlName="salaryPerItem"  placeholder="Salary per item">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.salaryPerItem"
                            [messages]="formValidationMsgs?.expertServices?.service?.salaryPerItem">
                          </app-error-html-handler>
                        </div>

                        <!-- <div class="" [ngClass]="showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input'" *ngIf="showExtraKmInput[i]"> -->
                        <div class="" [ngClass]="showSalaryPerItem[i] ? 'three-items' : (showExtraKmInput[i] ? 'saifu-input-inner' : 'saifu-input')" *ngIf="showExtraKmInput[i]">
                          <label for="">Extra Km/€</label>
                          <input type="text" formControlName="minimumKmPrice"  placeholder="Extra Km/€">
                          <app-error-html-handler
                            [ctrl]="serviceForm?.controls?.service?.controls?.minimumKmPrice"
                            [messages]="formValidationMsgs?.expertServices?.service?.minimumKmPrice">
                          </app-error-html-handler>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <br>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addService()">
                Aggiungi Servizio<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
    
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="kmIncluded">Minimum KM Included</label>
            <input type="text" name="name" formControlName="minimumKmIncluded">
            <app-error-html-handler
              [ctrl]="_expertForm.get('minimumKmIncluded')"
              [messages]="formValidationMsgs.minimumKmIncluded">
            </app-error-html-handler>
          </div>

          <div class="col-48 grid-element">
            <label for="">EXTRA FUORICITTÀ PREZZO</label>
            <input type="text" formControlName="extraOutSideCityKmPrice" placeholder="">
            <app-error-html-handler [ctrl]="_expertForm.get('extraOutSideCityKmPrice')" [messages]="formValidationMsgs?.extraOutSideCityKmPrice"></app-error-html-handler>
          </div>

        </fieldset>
        <br class="clear">
      </div>

      <div class="team-leader" *ngIf="groups.includes('admin')">
        <fieldset>
          <legend>NOTIFICHE:</legend>
            <div class="col-48 grid-element">
              <label class="toggle-container" for="receiveWhatsappMsg">
                <input type="checkbox" id="receiveWhatsappMsg" formControlName="receiveWhatsappMsg">
                <span class="toggle-switch"></span>
                Notifiche Whatsapp
              </label>
            </div>

            <div class="col-48 grid-element">
              <label class="toggle-container" for="receiveEmailMsg">
                <input type="checkbox" id="receiveEmailMsg" formControlName="receiveEmailMsg">
                <span class="toggle-switch"></span>
                Notifche Mail
              </label>
            </div>
        </fieldset>
        <br class="clear">
      </div>

      <!--
      <div class="expert-personal-info" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>SICUREZZA:</legend>
          <div class="col-48 grid-element">
            <label for="">CODICE UNIVOCO</label>
            <input type="text" formControlName="expertIndentityCode" placeholder="">
          </div>
        </fieldset>
      </div>
      -->

      <div class="vehicle-and-notes">
        <fieldset>
          <legend>DOCUMENTAZIONE E NOTE AND MEZZO:</legend>

          <div class="col-48 grid-element">
            <label>Mezzo</label>
            <div *ngFor="let vehicle of vehicles; let i = index" formArrayName="vehicles">
              <label class="original-label">
                <input type="checkbox" [formControlName]="i">
                {{vehicle.name}}
              </label>
            </div>
          </div>
          <div class="col-48 grid-element">
            <label for="noteExpert">Note{{ _expertForm.get("notes") | required }}</label>
            <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="vehicle-and-notes" *ngIf="profile && availableForUploadContract">
        <fieldset class="upload-fieldset">
          <legend>CONTRATTO:</legend>
          <div class="grid-element-full" formGroupName="user" *ngIf="profile">
            
            <!-- Drag & Drop Upload Area -->
            <div class="pdf-upload-container"
                [class.drag-over]="isDragging"
                [class.has-file]="uploadedFile"
                [class.error]="errorMessage"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
              
              <!-- Upload Icon & Text (shown when no file) -->
              <div class="upload-content" *ngIf="!uploadedFile && !isUploading">
                <div class="upload-icon">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1" />
                    <path d="M9 15l3 -3l3 3" />
                    <path d="M12 12l0 9" />
                  </svg>
                </div>
                <h3 class="upload-title">Trascina qui il tuo PDF</h3>
                <p class="upload-subtitle">oppure <button type="button" class="browse-btn" (click)="fileInput.click()">sfoglia i file</button></p>
                <p class="upload-hint">Solo file PDF • Max 5MB</p>
              </div>

              <!-- Upload Progress -->
              <div class="upload-progress" *ngIf="isUploading">
                <div class="spinner"></div>
                <p class="progress-text">Caricamento in corso...</p>
                <div class="progress-bar">
                  <div class="progress-fill" [style.width.%]="uploadProgress"></div>
                </div>
              </div>

              <!-- File Preview (shown when file uploaded) -->
              <div class="file-preview" *ngIf="uploadedFile && !isUploading">
                <div class="file-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                    <path d="M9 17h6" />
                    <path d="M9 13h6" />
                  </svg>
                </div>
                <div class="file-info">
                  <h4 class="file-name">{{ uploadedFile.name }}</h4>
                  <p class="file-size">{{ formatFileSize(uploadedFile.size) }}</p>
                </div>
                <button type="button" class="remove-btn" (click)="removeFile()" aria-label="Rimuovi file">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6l-12 12" />
                    <path d="M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <!-- Error Message -->
              <div class="error-message" *ngIf="errorMessage">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v4" />
                  <path d="M12 16h.01" />
                </svg>
                <span>{{ errorMessage }}</span>
              </div>

              <!-- Hidden File Input -->
              <input 
                #fileInput
                type="file" 
                accept=".pdf,application/pdf"
                (change)="onFileSelected($event)"
                style="display: none;">
            </div>
            
          </div>
        </fieldset>
        <br class="clear">
      </div>

      <div class="vehicle-and-notes" *ngIf="profile">
        <fieldset>
          <legend>Password:</legend>
          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
            <label>Password</label>
            <input type="password" name="password1" formControlName="password1">
            <app-error-html-handler [ctrl]="_expertForm.get('user').get('password1')"
              [messages]="formValidationMsgs.user.password1">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
            <label>Ripeti password</label>
            <input type="password" name="password2" formControlName="password2">
            <app-error-html-handler [ctrl]="_expertForm.get('user').get('password2')"
              [messages]="formValidationMsgs.user.password2">
            </app-error-html-handler>
          </div>
        </fieldset>
      </div>

      <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
        <fieldset>
          <legend>CAMPI OBBLIGATORI:</legend>
          <ul class="error-list">
            <li *ngFor="let error of getErrorMessages()">
              {{ translateErrorMessage(error) }}
            </li>
          </ul>
        </fieldset>
      </div>


      <div class="center mt-20">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()"
          [disabled]="!_expertForm?.valid || tmpBtnDisabled" >
          Salva<i class="ml-10 far fa-save"></i>
        </button>
      </div>
    </form>
    <br class="clear">
  </div>
</section>
